//const prod = { BASE_URL: 'https://admin.marpewellbeing.uk' };
const prod = { BASE_URL: 'http://46.101.42.163:8080' };

const dev = { BASE_URL: 'http://46.101.42.163:8080' };
export const config = process.env.REACT_APP_STAGE === 'development' ? dev : prod;
